import PropTypes from 'prop-types'
import React from 'react'
import Link from 'components/Link'
import IconV2, { ICON_TYPES } from 'components/Icon.v2'

function getClassName (props) {
  const { showToolTip, vertical = false } = props
  const className = ['more-info']
  if (showToolTip) {
    className.push('more-info--show-tooltip')
  }
  if (vertical) {
    className.push('more-info--vertical')
  }
  return className.join(' ')
}

function MoreInfo (props) {
  const { url } = props
  return (
    <Link
      className={getClassName(props)}
      aria-label="more information"
      type="button"
      to={url}
    >
      <IconV2
        className="more-info__trigger"
        type={ICON_TYPES.ELLIPSIS}
      />
    </Link>
  )
}

MoreInfo.propTypes = {
  url: PropTypes.string.isRequired,
  showToolTip: PropTypes.bool,
  active: PropTypes.bool,
}

export default MoreInfo
